import * as yup from 'yup';

const DESCRIPTION_REGEX: RegExp = /^[A-Za-z0-9.,\-\s]{1,500}$/;

export const validationSchema = yup.object().shape({
	description: yup
		.string()
		.required('Description is required')
		.max(500, 'Description cannot exceed 500 characters')
		.matches(DESCRIPTION_REGEX, "Only alphanumeric characters, space, '.', ',' and '-' are allowed"),
	csvFile: yup.mixed().required('CSV file is required')
});
